export default "__VITE_ASSET__A2R5J_77__"